/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Close_LabelInputs */



/**
* | output |
* | --- |
* | "Close plain text import modal" |
*
* @param {Plain_Text_Import_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_close_label = /** @type {((inputs?: Plain_Text_Import_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la fenetre d'importation de texte brut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Modal zum Importieren von Klartext schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la finestra modale di importazione del testo normale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно импорта обычного текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar el modal de importación de texto sin formato")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭纯文本导入模态框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレーンテキストインポートモーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("साधारण पाठ आयात मॉडल बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar modal de importação de texto simples")
	return /** @type {LocalizedString} */ ("Close plain text import modal")
});